<template>
  <b-container class="mb-7" id="modules" v-if="modules.length > 0">
    <b-row class="mb-4">
      <b-col>
        <h2>Bildungsmodule</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        v-for="module in moduleList"
        :key="module.id"
        cols="12"
        md="6"
        lg="4"
        class="mb-4"
      >
        <article class="module-card h-100">
          <b-badge v-if="module.suitableFor" class="module-badge" pill>
            {{ module.suitableFor }}
          </b-badge>
          <h3 class="module-title">{{ module.title }}</h3>
          <div class="module-description" v-html="module.html"></div>
        </article>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import { sanitizeHtml } from "@/utils/richText";

export default {
  name: "Modules",
  computed: {
    ...mapGetters(["modules"]),
    moduleList() {
      return this.modules.map(m => ({
        id: m.id,
        title: m.title,
        suitableFor: m.suitableFor,
        html: sanitizeHtml(m.descriptionHTML)
      }));
    }
  }
};
</script>

<style lang="scss" scoped>
.modules-intro {
  font-size: 14pt;
  max-width: 45rem;
  margin-bottom: 2rem;
}

.module-card {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  background: #fff;
  border-top: 4px solid var(--primary);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.18);
  }
}

.module-badge {
  align-self: flex-start;
  margin-bottom: 0.75rem;
  padding: 0.4em 0.9em;
  background-color: var(--primary);
  color: #fff;
  font-weight: normal;
  font-size: 0.8rem;
  white-space: normal;
  text-align: left;
}

.module-title {
  font-size: 1.4rem;
  margin-bottom: 0.75rem;
}

.module-description {
  ::v-deep p:last-child {
    margin-bottom: 0;
  }
}
</style>
